import React, { useEffect, useState } from 'react';
import { useForm } from '../../../../shared/hooks/form-hook';
// import { useHttpClient } from '../../../../shared/hooks/http-hook';
import Input from '../../../../shared/components/FormElements/input';
import ImageUpload from '../../../../shared/components/FormElements/imageUpload';
import { VALIDATOR_REQUIRE } from '../../../../shared/util/validators';
import { Button } from '@mui/material';
import { NavLink, useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';


import './updateCourse.css';




const UpdateCourse = () => {
    const { courseId }  = useParams();
    const history = useHistory();
   
    const [isLoading, setIsLoading] = useState(false)
    const [isLoaded, setIsLoaded] = useState();

    const [formState, inputHandler, setFormData] = useForm( 
        {
            title: {
                value:'',
                isValid: false
            },
            intro: {
                value: '',
                isValid: false
            }, 
            who: {
                value: '',
                isValid: false
            },
            image: {
                value: null,
                isValid: false
            },
            day: {
                value:'',
                isValid: false
            },
            time: {
                value:'',
                isValid: false
            },
            date: {
                value:'',
                isValid: false
            },
            location: {
                value:'',
                isValid: false
            }
       },
false
    
);
 

useEffect(() => {
    const fetchMend = async () => {
        setIsLoading(true)
        try{
          const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/course/${courseId}`);
          const responseData = await response.json();
          setIsLoaded(responseData.course);

          setFormData(
            {
                title:{
                    value: responseData.course.title,
                    isValid: true
                },
                intro: {
                    value: responseData.course.intro,
                    isValid: true
                }, 
                image: {
                    value: responseData.course.image ,
                    isValid: true
                },
                who: {
                    value: responseData.course.who ,
                    isValid: true
                },
                day: {
                    value: responseData.course.day ,
                    isValid: true
                },
                time: {
                    value: responseData.course.time ,
                    isValid: true
                },
                date: {
                    value: responseData.course.date ,
                    isValid: true
                },
                location: {
                    value: responseData.course.location ,
                    isValid: true
                }
            },
            true
        ); 
        } catch (err) {
            console.log(err.message)
        }
      
    }
   
    fetchMend();
}, [courseId, setFormData])

   

    const submitHandler = async (event) => {
        event.preventDefault();

        try {
            const formData = new FormData();
            formData.append('title', formState.inputs.title.value);
            formData.append('intro', formState.inputs.intro.value);
            formData.append('who', formState.inputs.who.value);
            formData.append('day', formState.inputs.day.value);
            formData.append('time', formState.inputs.time.value);
            formData.append('date', formState.inputs.date.value);
            formData.append('location', formState.inputs.location.value);

            // Append image if a new one is uploaded
            if (formState.inputs.image.value instanceof File){
                formData.append('image', formState.inputs.image.value);
            }


             await fetch(`${process.env.REACT_APP_BACKEND_URL}/course/${courseId}`, {
                method: 'PATCH',
                body: formData,
                // headers: {
                //     'Content-Type': 'application/json'
                // }
            });

        } catch (err) {
            console.log(err.message)
        }

           
        
        // console.log(formState.inputs) // sending to backend
        history.push('/')
    }

    

    if(!isLoading){
        return<div> <h2>Loading...</h2> </div>
        

           
    }

    if(!isLoaded){
        return <div>Article not found!</div>
    }
return(

        <main className='update-form'>

            <NavLink to='/'><FontAwesomeIcon icon={faArrowLeft} className='font-controller-announce'/></NavLink>
            
            <h1>This is Edit page</h1>         
            <div className='update-form-container'>

           { isLoaded &&  (
            <form onSubmit={submitHandler} className='form-controllor'>        
                <Input 
                    id='title'
                    element='input'
                    type='text'
                    label='Title'
                    autoComplete='off' 
                    validators={[VALIDATOR_REQUIRE()]} 
                    errorText='Please enter a valid title'
                    onInput={inputHandler}
                    initialValue={isLoaded.title}
                />
                <ImageUpload 
                  id='image'      
                  onInput={inputHandler}
                  initialValue={isLoaded.image}
                />

                <Input 
                    id='intro'
                    element='textarea'
                    type='text'
                    label='Intro'
                    autoComplete='off' 
                    errorText='Field is empty'
                    validators={[VALIDATOR_REQUIRE()]}  
                    onInput={inputHandler}
                    initialValue={isLoaded.intro}
                />
                <Input 
                    id='who'
                    element='input'
                    type='text'
                    label='Who'
                    autoComplete='off' 
                    errorText='Field is empty'
                    validators={[VALIDATOR_REQUIRE()]}  
                    onInput={inputHandler}
                    initialValue={isLoaded.who}
                />
                <Input 
                    id='day'
                    element='input'
                    type='text'
                    label='Day'
                    autoComplete='off' 
                    errorText='Field is empty'
                    validators={[VALIDATOR_REQUIRE()]}  
                    onInput={inputHandler}
                    initialValue={isLoaded.day}
                />
                <Input 
                    id='time'
                    element='textarea'
                    type='text'
                    label='Time'
                    autoComplete='off' 
                    errorText='Field is empty'
                    validators={[VALIDATOR_REQUIRE()]}  
                    onInput={inputHandler}
                    initialValue={isLoaded.time}
                />
                <Input 
                    id='date'
                    element='textarea'
                    type='text'
                    label='Date'
                    autoComplete='off' 
                    errorText='Field is empty'
                    validators={[VALIDATOR_REQUIRE()]}  
                    onInput={inputHandler}
                    initialValue={isLoaded.date}
                />
                <Input 
                    id='location'
                    element='textarea'
                    type='text'
                    label='Location'
                    autoComplete='off' 
                    errorText='Field is empty'
                    validators={[VALIDATOR_REQUIRE()]}  
                    onInput={inputHandler}
                    initialValue={isLoaded.location}
                />
                <Button type='submit' variant='contained' style={{marginTop: '20px'}}>Update</Button>
            </form>
             )} 
            </div>
        </main>
    )
}

export default UpdateCourse;